import "./About.module.css";
import Header from "@/reusable_sections/Header";
import OurHistoryAndMastery from "./sections/OurHistoryAndMastery";
import OurCompassionateExperts from "./sections/OurCompassionateExperts";
import EducationalPhilosophy from "./sections/EducationalPhilosophy";
import FooterInfo from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <OurHistoryAndMastery />
      <OurCompassionateExperts />
      <EducationalPhilosophy />
      <FooterInfo />
    </div>;
}